const pleasantColors = [
  '#B5EAD7', '#6A67CE', '#A8D5BA', '#B39CD0', '#4C9AFF', '#FFA07A', '#0052CC',
  '#36B37E', '#6554C0', '#00B8D9', '#FFC400', '#FF5630', '#00A3BF', '#FFAB00',
  '#79F2C0', '#D291BC', '#C5E384', '#FFBCBC', '#F7A072', '#A2D5F2'
];

const ActualVsEstimated = (
  data = [],
  reportCount = 5,
  legend = ['Estimated Time (hrs)', 'Time Logged (hrs)']
) => {
  const useDataZoom = data.length > 20;

  const names = data.map((item, index) => {
    const firstName = item.profile?.firstName || '';
    const lastName = item.profile?.lastName || '';
    const fullName = `${firstName} ${lastName}`.trim();
    return fullName || `User ${index + 1}`;
  });

  const estimatedData = data.map(item => item.estimated ?? 0);
  const actualData = data.map(item => item.actual ?? 0);

  return {
    color: pleasantColors,
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: (params) => {
        const index = params[0]?.dataIndex ?? 0;
        const fullName = names[index];
        const est = estimatedData[index];
        const act = actualData[index];
        return `<b>${fullName}</b><br/>🕒 Estimated: ${est} hr(s)<br/>⏱️ Logged: ${act} hr(s)`;
      }
    },
    legend: {
      show: false,
      bottom: 0,
      data: legend
    },
    grid: {
      left: 0,
      right: 0,
      bottom: useDataZoom ? 50 : 35,
      top: 20,
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: names.map(name => name.slice(0, 2).toUpperCase()),
      axisLabel: {
        interval: 0,
        rotate: 0
      }
    },
    yAxis: {
      type: 'value',
      name: 'Hours'
    },
    dataZoom: useDataZoom
      ? [
        {
          type: 'inside',
          xAxisIndex: 0,
          start: 0,
          end: 40
        },
        {
          type: 'slider',
          show: false,
          xAxisIndex: 0,
          height: 15,
          bottom: 40
        }
      ]
      : [],
    series: [
      {
        name: legend[0],
        type: 'bar',
        data: estimatedData,
        itemStyle: {
          borderRadius: [4, 4, 0, 0]
        },
        label: {
          show: true,
          position: 'top',
          formatter: '{c}',
          color: '#000',
          fontSize: 12
        }
      },
      {
        name: legend[1],
        type: 'bar',
        data: actualData,
        itemStyle: {
          borderRadius: [4, 4, 0, 0]
        },
        label: {
          show: true,
          position: 'top',
          formatter: '{c}',
          color: '#000',
          fontSize: 12
        }
      }
    ]
  };
};

export default ActualVsEstimated;
